import { render, staticRenderFns } from "./smartOrg.vue?vue&type=template&id=9861a1fa&scoped=true&"
import script from "./smartOrg.vue?vue&type=script&lang=ts&"
export * from "./smartOrg.vue?vue&type=script&lang=ts&"
import style0 from "./smartOrg.vue?vue&type=style&index=0&lang=less&"
import style1 from "./smartOrg.vue?vue&type=style&index=1&id=9861a1fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9861a1fa",
  null
  
)

export default component.exports